import styled from "styled-components"
import TransferContainer from "./timeline/styled/TransferContainer"
import { TxlActionButton } from "./TxlButton"

const DownloadArea = styled.div`
  position: absolute;
  width: ${props => props.theme.download.width}px;
  height: ${props => props.theme.download.height}px;
  bottom: ${props => props.theme.download.bottom}px;
  left: 50%;
  margin-top: ${props => -props.theme.download.height / 2}px;
  margin-left: ${props => -props.theme.download.width / 2}px;
  ${TransferContainer} {
    position: relative;
    margin: 0;
    background-color: ${props => props.theme.color.translucid};
  }
  ${TxlActionButton} {
    position: absolute;
    bottom: 0;
    margin-left: -30px;
  }
`

export default DownloadArea
